export default "__VITE_ASSET__EvCGOMeQ__"